<template>
  <v-container fluid>
    <!-- Loading Dialog -->
    <v-dialog v-model="loading" max-width="200" persistent>
      <v-card elevation="12" class="text-center" color="white">
        <v-card-text>
          <v-progress-circular indeterminate color="primary" size="20" class="pt-10"></v-progress-circular>
          <div class="loading-text pl-4">Carregando...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dashboard -->
    <v-row v-if="simuladosResults.length > 0" class="dashboard" align="center" justify="center">
      <!-- Taxa de Acertos Global -->
<!-- filepath: c:\Users\gabri\Documents\GitHub\medexperts\src\views\SimuladosResults.vue -->

<!-- filepath: c:\Users\gabri\Documents\GitHub\medexperts\src\views\SimuladosResults.vue -->
<!-- <v-col cols="12" sm="12" md="12" lg="12">
  <v-card class="metric-card elevation-3">
    <v-card-title class="text-h6 font-weight-bold mb-4">Temas por Simulado</v-card-title>
    <v-card-text>
      <div v-for="(themes, simulado) in SimuladosThemes" :key="simulado" class="mb-4">
        <h3 class="text-subtitle-1 font-weight-bold">{{ simulado }}</h3>
        <v-list dense>
          <v-list-item
            v-for="(count, theme) in countThemes(themes)"
            :key="theme"
          >
            <v-list-item-content>
              <span class="theme-name">{{ theme }}</span>
            </v-list-item-content>
            <v-list-item-action>
              <span class="theme-count">{{ count }} questão(ões)</span>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</v-col> -->
      <v-col cols="12" sm="6" md="5" lg="5">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Taxa de Acertos Global</v-card-title>
          <v-card-text class="d-flex align-center justify-space-between">
            <v-progress-circular
              :size="120"
              :width="15"
              :value="globalAccuracy * 100"
              color="Purple"
            >
              <h2 class="mb-0">{{ (globalAccuracy * 100).toFixed(2) }}%</h2>
            </v-progress-circular>
            <div class="ml-4">
              <p class="mb-2">
                <strong>Total de Simulados Realizados:</strong> {{ simuladosResults.length }}
              </p>
              <p class="mb-2">
                <strong>Total de Questões Respondidas:</strong> {{ totalQuestions }}
              </p>
              <p class="mb-2">
                <strong>Total de Acertos:</strong> {{ totalRight }}
              </p>
              <p>
                <strong>Total de Erros:</strong> {{ totalWrong }}
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <small>*Inclui todos os simulados já realizados.</small>
          </v-card-actions>
        </v-card>
      </v-col>

            <!-- Taxa de Acertos por Tipo de Prova -->
      <v-col cols="12" sm="6" md="5" lg="5">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Taxa de Acertos por Tipo de Prova</v-card-title>
          <v-card-text>
            <div class="chart-container">
              <bar-chart :data="barChartData" :options="barChartOptions" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Último Simulado Teórico -->
      <v-col cols="12" sm="6" md="5" lg="5">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Último Simulado Teórico</v-card-title>
          <v-card-text class="d-flex align-center justify-space-between">
            <v-progress-circular
              :size="120"
              :width="15"
              :value="lastTheoreticalSimulado.accuracy"
              color="primary"
            >
              <h2 class="mb-0">{{ lastTheoreticalSimulado.accuracy.toFixed(2) }}%</h2>
            </v-progress-circular>
            <div class="ml-4">
              <p class="mb-2">
                <strong>Nome:</strong> {{ lastTheoreticalSimulado.name }}
              </p>
              <p class="mb-2">
                <strong>Data:</strong> {{ lastTheoreticalSimulado.date }}
              </p>
              <p class="mb-2">
                <strong>Total de Questões:</strong> {{ lastTheoreticalSimulado.totalQuestions }}
              </p>
              <p class="mb-2">
                <strong>Total de Acertos:</strong> {{ lastTheoreticalSimulado.totalRight }}
              </p>
              <p>
                <strong>Total de Erros:</strong> {{ lastTheoreticalSimulado.totalWrong }}
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <small>*Último simulado teórico realizado.</small>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Último Simulado Teórico-Prático -->
      <v-col cols="12" sm="6" md="5" lg="5">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Último Simulado Teórico-Prático</v-card-title>
          <v-card-text class="d-flex align-center justify-space-between">
            <v-progress-circular
              :size="120"
              :width="15"
              :value="lastPracticalSimulado.accuracy"
              color="success"
            >
              <h2 class="mb-0">{{ lastPracticalSimulado.accuracy.toFixed(2) }}%</h2>
            </v-progress-circular>
            <div class="ml-4">
              <p class="mb-2">
                <strong>Nome:</strong> {{ lastPracticalSimulado.name }}
              </p>
              <p class="mb-2">
                <strong>Data:</strong> {{ lastPracticalSimulado.date }}
              </p>
              <p class="mb-2">
                <strong>Total de Questões:</strong> {{ lastPracticalSimulado.totalQuestions }}
              </p>
              <p class="mb-2">
                <strong>Total de Acertos:</strong> {{ lastPracticalSimulado.totalRight }}
              </p>
              <p>
                <strong>Total de Erros:</strong> {{ lastPracticalSimulado.totalWrong }}
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <small>*Último simulado teórico-prático realizado.</small>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Lista de Simulados Concluídos -->
      <v-col cols="12" sm="3" md="3" lg="3">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Teóricos ({{ theoreticalSimulados.length }})</v-card-title>
          <v-card-text>
            <div class="simulados-container">
                <v-list dense>
                  <v-list-item
                    v-for="sim in theoreticalSimulados"
                    :key="sim.simName"
                    class="simulados-item"
                  >
                    <div class="sim-item-content">
                      <span class="sim-name">{{ sim.simName }}</span>
                      <span :class="getAccuracyColor(sim.simRightPercentage)" class="sim-percentage">
                        {{ (sim.simRightPercentage * 100).toFixed(2) }}%
                      </span>
                    </div>
                  </v-list-item>
                </v-list>

            </div>
          </v-card-text>
        </v-card>
      </v-col>

            <!-- Lista de Simulados Concluídos -->
      <v-col cols="12" sm="3" md="3" lg="3">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Teórico-Práticos ({{ practicalSimulados.length }})</v-card-title>
          <v-card-text>
            <div class="simulados-container">
                <v-list dense>
                  <v-list-item
                    v-for="sim in practicalSimulados"
                    :key="sim.simName"
                    class="simulados-item"
                  >
                    <div class="sim-item-content">
                      <span class="sim-name">{{ sim.simName }}</span>
                      <span :class="getAccuracyColor(sim.simRightPercentage)" class="sim-percentage">
                        {{ (sim.simRightPercentage * 100).toFixed(2) }}%
                      </span>
                    </div>
                  </v-list-item>
                </v-list>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

         <!-- Resumo de Questões por Tema -->
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">
            Taxa de Acertos por Tema
              <v-icon 
  small 
  @click="showHelp = true" 
  class="minimal-icon"
>
  mdi-help-circle
</v-icon>
          </v-card-title>

          <v-card-text>
            <div class="table-container">
              <v-simple-table class="aesthetic-table">
                <thead>
                  <tr>
                    <th class="text-left" @click="sortTable('theme')">
                      Tema
                      <v-icon small>{{ sortColumn === 'theme' ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : '' }}</v-icon>
                    </th>
                    <th class="text-center" @click="sortTable('total')">
                      Total de Questões
                      <v-icon small>{{ sortColumn === 'total' ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : '' }}</v-icon>
                    </th>
                    <th class="text-center" @click="sortTable('correct')">
                      Acertos
                      <v-icon small>{{ sortColumn === 'correct' ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : '' }}</v-icon>
                    </th>
                    <th class="text-center" @click="sortTable('accuracy')">
                      Taxa de Acertos (%)
                      <v-icon small>{{ sortColumn === 'accuracy' ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : '' }}</v-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="theme in sortedThemes" 
                    :key="theme"
                  >
                    <td>{{ theme }}</td>
                    <td class="text-center">{{ themesSummary[theme].total }}</td>
                    <td class="text-center">{{ themesSummary[theme].correct }}</td>
                    <td class="text-center">
                      <span
                        :class="getAccuracyColor(themesSummary[theme].correct / themesSummary[theme].total, themesSummary[theme].total)"
                        class="accuracy-percentage"
                      >
                        {{ ((themesSummary[theme].correct / themesSummary[theme].total) * 100).toFixed(2) }}%
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-card-text>
        </v-card>
             <!-- LEGENDA VISÍVEL -->
          <div class="legend-row">
            <div class="legend-item">
              <span class="legend-color gray"></span>
              <span>Baixo volume de questões</span>
            </div>
            <div class="legend-item">
              <span class="legend-color red"></span>
              <span>Taxa < 60%</span>
            </div>
            <div class="legend-item">
              <span class="legend-color yellow"></span>
              <span>Taxa 60‑75% / volume crescente</span>
            </div>
            <div class="legend-item">
              <span class="legend-color green"></span>
              <span>Taxa > 75%</span>
            </div>
          </div>
      </v-col>

      <!-- Taxa de Questões e Acertos por Tema -->
<v-col cols="12" sm="12" md="12" lg="12">
  <v-card class="metric-card elevation-3">
    <v-card-title class="text-h6 font-weight-bold mb-4">Questões e Acertos por Tema (Top 10)</v-card-title>
    <v-card-text>
      <div class="chart-container taller-chart" v-if="chartData">
        <bar-chart :data="chartData" :options="questionsBarChartOptions" />
      </div>
      <div v-else>
        <p>Carregando dados...</p>
      </div>
    </v-card-text>
  </v-card>
</v-col>

      <!-- Evolução ao Longo do Tempo
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold">Evolução ao Longo do Tempo</v-card-title>
          <v-card-text>
            <line-chart :data="evolutionData" />
          </v-card-text>
        </v-card>
      </v-col> -->

      <!-- Evolução dos Simulados Teóricos -->
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold">Evolução dos Simulados Teóricos</v-card-title>
          <v-card-text>
            <line-chart :data="evolutionTheoreticalData" />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Evolução dos Simulados Teórico-Práticos -->
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold">Evolução dos Simulados Teórico-Práticos</v-card-title>
          <v-card-text>
            <line-chart :data="evolutionPracticalData" />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Volume de Questões e Acertos por Tema -->
      <!-- <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="metric-card elevation-3">
          <v-card-title class="text-h6 font-weight-bold mb-4">Volume de Questões e Acertos por Tema</v-card-title>
          <v-card-text>
            <div v-for="(themes, simulado) in mergedSimuladosThemes" :key="simulado" class="mb-4">
              <h3 class="text-subtitle-1 font-weight-bold">{{ simulado }}</h3>
              <v-list dense>
                <v-list-item
                  v-for="(data, theme) in themes"
                  :key="theme"
                >
                  <v-list-item-content>
                    <span class="theme-name">{{ theme }}</span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span class="theme-count">
                      {{ data.total }} questão(ões), {{ data.correct }} acerto(s)
                    </span>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>
        </v-card>
      </v-col> -->

   
    </v-row>

    <!-- Nenhum dado disponível -->
    <v-row v-else justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="text-center elevation-5">
          <v-card-text>
            <v-icon x-large color="grey lighten-1">mdi-folder-question</v-icon>
            <p class="mt-3 font-weight-bold">Nenhum dado disponível.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de Ajuda -->
    <v-dialog v-model="showHelp" max-width="500">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">Como funciona?</v-card-title>
        <v-card-text>
          <div class="help-dialog-content">
        <div class="help-item">
          <span class="help-color gray"></span>
          <span><strong>Cinza:</strong> Baixo volume de questões para o tema.</span>
        </div>
        <div class="help-item">
          <span class="help-color red"></span>
          <span><strong>Vermelho:</strong> Taxa de acertos abaixo de 60%.</span>
        </div>
        <div class="help-item">
          <span class="help-color yellow"></span>
          <span><strong>Amarelo:</strong> Taxa de acertos entre 60% e 75%. Ou Volume de questões crescente.</span>
        </div>
        <div class="help-item">
          <span class="help-color green"></span>
          <span><strong>Verde:</strong> Taxa de acertos acima de 75%.</span>
        </div>
      </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" text @click="showHelp = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import LineChart from '@/components/LineChart.vue';
import BarChart from '@/components/BarChart.vue'; // Adicione esta linha

export default {
  components: {
    LineChart,
    BarChart, // Registre o componente aqui
  },
  data() {
    return {
      showHelp: false,
      sortColumn: 'theme', // Coluna padrão para ordenação
      sortDirection: 'asc', // Direção padrão (ascendente)
      chartData: null, // Dados do gráfico
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadSimuladosData();
    });
  },
  watch: {
    admin(newAdmin) {
      if (typeof newAdmin === 'string' && newAdmin.trim() !== '' && !newAdmin.includes(',')) {
        this.loadSimuladosData();
      }
    },
    themesSummary: {
      immediate: true, // Executa o watch assim que o componente é montado
      handler(newThemesSummary) {
        if (!newThemesSummary || Object.keys(newThemesSummary).length === 0) {
          this.chartData = null;
          return;
        }

        // Ordena os temas pelo total de questões em ordem decrescente
        const sortedThemes = Object.entries(newThemesSummary)
          .sort(([, a], [, b]) => b.total - a.total) // Ordena pelo total de questões
          .slice(0, 10); // Pega apenas os 10 primeiros

        const labels = sortedThemes.map(([theme]) => theme); // Nomes dos temas
        const totalQuestions = sortedThemes.map(([, data]) => data.total); // Total de questões por tema
        const correctAnswers = sortedThemes.map(([, data]) => data.correct); // Total de acertos por tema

        this.chartData = {
          labels,
          datasets: [
            {
              label: 'Total de Questões',
              data: totalQuestions,
              backgroundColor: '#1976d2',
              borderColor: '#115293',
              borderWidth: 1,
            },
            {
              label: 'Acertos',
              data: correctAnswers,
              backgroundColor: '#4caf50',
              borderColor: '#357a38',
              borderWidth: 1,
            },
          ],
        };
      },
    },
  },
  computed: {
    admin() {
      return this.$store.getters.admin;
    },
    loading() {
      return this.$store.getters.loading;
    },
    simuladosResults() {
      return this.$store.getters.loadedSimuladosResults;
    },
    SimuladosThemes() {
      return this.$store.getters.loadedSimuladosThemes;
    },
    totalQuestions() {
      return this.simuladosResults.reduce((sum, sim) => sum + sim.simQuestionsAnswered, 0);
    },
    totalRight() {
      return this.simuladosResults.reduce((sum, sim) => sum + sim.simTotalRight, 0);
    },
    totalWrong() {
      return this.totalQuestions - this.totalRight;
    },
    globalAccuracy() {
      return this.totalQuestions > 0 ? this.totalRight / this.totalQuestions : 0;
    },
    theoreticalAccuracy() {
      const theoretical = this.simuladosResults.filter(
        sim => sim.simName.includes('Teórico') && !sim.simName.includes('Teórico-Prático')
      );
      const totalRight = theoretical.reduce((sum, sim) => sum + sim.simTotalRight, 0);
      const totalQuestions = theoretical.reduce((sum, sim) => sum + sim.simQuestionsAnswered, 0);
      return totalQuestions > 0 ? totalRight / totalQuestions : 0;
    },
    practicalAccuracy() {
      const practical = this.simuladosResults.filter(sim => sim.simName.includes('Teórico-Prático'));
      const totalRight = practical.reduce((sum, sim) => sum + sim.simTotalRight, 0);
      const totalQuestions = practical.reduce((sum, sim) => sum + sim.simQuestionsAnswered, 0);
      return totalQuestions > 0 ? totalRight / totalQuestions : 0;
    },
    evolutionData() {
      return this.simuladosResults.map(sim => ({
        date: new Date(sim.simSubmissionDate).toLocaleDateString(),
        name: sim.simName,
        accuracy: sim.simRightPercentage * 100,
      }));
    },
    // Dados para o gráfico de evolução dos simulados teóricos
    evolutionTheoreticalData() {
  return this.simuladosResults
    .filter(sim => sim.simName.includes('Teórico') && !sim.simName.includes('Teórico-Prático'))
    .slice() // evita mutações no array original
    .sort((a, b) => new Date(a.simSubmissionDate) - new Date(b.simSubmissionDate))
    .map(sim => ({
      date: new Date(sim.simSubmissionDate).toLocaleDateString(),
      name: sim.simName,
      accuracy: sim.simRightPercentage * 100,
    }));
},

    // Dados para o gráfico de evolução dos simulados teórico-práticos
    evolutionPracticalData() {
  return this.simuladosResults
    .filter(sim => sim.simName.includes('Teórico-Prático'))
    .slice()
    .sort((a, b) => new Date(a.simSubmissionDate) - new Date(b.simSubmissionDate))
    .map(sim => ({
      date: new Date(sim.simSubmissionDate).toLocaleDateString(),
      name: sim.simName,
      accuracy: sim.simRightPercentage * 100,
    }));
},
    lastSimulado() {
      if (!this.simuladosResults.length) {
        return { name: 'N/A', date: 'N/A', totalQuestions: 0, totalRight: 0, totalWrong: 0, accuracy: 0 };
      }

      const lastSimulado = this.simuladosResults.reduce((latest, sim) => {
        const currentDate = new Date(sim.simSubmissionDate);
        const latestDate = new Date(latest.simSubmissionDate);
        return currentDate > latestDate ? sim : latest;
      });

      return {
        name: lastSimulado.simName,
        date: new Date(lastSimulado.simSubmissionDate).toLocaleDateString(),
        totalQuestions: lastSimulado.simQuestionsAnswered,
        totalRight: lastSimulado.simTotalRight,
        totalWrong: lastSimulado.simQuestionsAnswered - lastSimulado.simTotalRight,
        accuracy: lastSimulado.simRightPercentage * 100,
      };
    },
    lastTheoreticalSimulado() {
      if (!this.simuladosResults.length) {
        return { name: 'N/A', date: 'N/A', totalQuestions: 0, totalRight: 0, totalWrong: 0, accuracy: 0 };
      }

      const theoreticalSimulados = this.simuladosResults.filter(
        sim => sim.simName.includes('Teórico') && !sim.simName.includes('Teórico-Prático')
      );

      if (!theoreticalSimulados.length) {
        return { name: 'N/A', date: 'N/A', totalQuestions: 0, totalRight: 0, totalWrong: 0, accuracy: 0 };
      }

      const lastTheoreticalSimulado = theoreticalSimulados.reduce((latest, sim) => {
        const currentDate = new Date(sim.simSubmissionDate);
        const latestDate = new Date(latest.simSubmissionDate);
        return currentDate > latestDate ? sim : latest;
      });

      return {
        name: lastTheoreticalSimulado.simName,
        date: new Date(lastTheoreticalSimulado.simSubmissionDate).toLocaleDateString(),
        totalQuestions: lastTheoreticalSimulado.simQuestionsAnswered,
        totalRight: lastTheoreticalSimulado.simTotalRight,
        totalWrong: lastTheoreticalSimulado.simQuestionsAnswered - lastTheoreticalSimulado.simTotalRight,
        accuracy: lastTheoreticalSimulado.simRightPercentage * 100,
      };
    },
    lastPracticalSimulado() {
      if (!this.simuladosResults.length) {
        return { name: 'N/A', date: 'N/A', totalQuestions: 0, totalRight: 0, totalWrong: 0, accuracy: 0 };
      }

      // Encontra o último simulado teórico-prático
      const practicalSimulados = this.simuladosResults
        .filter(sim => sim.simName.includes('Teórico-Prático'));

      if (!practicalSimulados.length) {
        return { name: 'N/A', date: 'N/A', totalQuestions: 0, totalRight: 0, totalWrong: 0, accuracy: 0 };
      }

      const lastPracticalSimulado = practicalSimulados.reduce((latest, sim) => {
          const currentDate = new Date(sim.simSubmissionDate);
          const latestDate = new Date(latest.simSubmissionDate);
          return currentDate > latestDate ? sim : latest;
        });

      return {
        name: lastPracticalSimulado.simName,
        date: new Date(lastPracticalSimulado.simSubmissionDate).toLocaleDateString(),
        totalQuestions: lastPracticalSimulado.simQuestionsAnswered,
        totalRight: lastPracticalSimulado.simTotalRight,
        totalWrong: lastPracticalSimulado.simQuestionsAnswered - lastPracticalSimulado.simTotalRight,
        accuracy: lastPracticalSimulado.simRightPercentage * 100,
      };
    },
    barChartData() {
      return {
        labels: ['Teóricos', 'Teórico-Práticos'],
        datasets: [
          {
            label: 'Taxa de Acertos (%)',
            data: [(this.theoreticalAccuracy * 100).toFixed(2), (this.practicalAccuracy * 100).toFixed(2)],
            backgroundColor: ['#1976d2', '#4caf50'],
            borderColor: ['#115293', '#357a38'],
            borderWidth: 1,
          },
        ],
      };
    },
    barChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.raw}%`;
              },
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Tipo de Prova',
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Taxa de Acertos (%)',
            },
            max: 100,
          },
        },
      };
    },
    questionsBarChartData() {
      if (!this.themesSummary || Object.keys(this.themesSummary).length === 0) {
        return {
          labels: [],
          datasets: [],
        };
      }

      // Ordena os temas pelo total de questões em ordem decrescente
      const sortedThemes = Object.entries(this.themesSummary)
        .sort(([, a], [, b]) => b.total - a.total) // Ordena pelo total de questões
        .slice(0, 10); // Pega apenas os 10 primeiros

      const labels = sortedThemes.map(([theme]) => theme); // Nomes dos temas
      const totalQuestions = sortedThemes.map(([, data]) => data.total); // Total de questões por tema
      const correctAnswers = sortedThemes.map(([, data]) => data.correct); // Total de acertos por tema

      return {
        labels,
        datasets: [
          {
            label: 'Total de Questões',
            data: totalQuestions,
            backgroundColor: '#1976d2',
            borderColor: '#115293',
            borderWidth: 1,
          },
          {
            label: 'Acertos',
            data: correctAnswers,
            backgroundColor: '#4caf50',
            borderColor: '#357a38',
            borderWidth: 1,
          },
        ],
      };
    },
    questionsBarChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.dataset.label}: ${context.raw}`;
              },
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Temas',
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Quantidade',
            },
          },
        },
      };
    },
    // Filtra os simulados teóricos
    theoreticalSimulados() {
      return this.simuladosResults
        .filter(sim => sim.simName.includes('Teórico') && !sim.simName.includes('Teórico-Prático'))
        .sort((a, b) => new Date(b.simSubmissionDate) - new Date(a.simSubmissionDate));
    },
    // Filtra os simulados teórico-práticos
    practicalSimulados() {
      return this.simuladosResults
        .filter(sim => sim.simName.includes('Teórico-Prático'))
        .sort((a, b) => new Date(b.simSubmissionDate) - new Date(a.simSubmissionDate));
    },
    mergedSimuladosThemes() {
      const mergedData = {};

      this.simuladosResults.forEach(simulado => {
        const simName = simulado.simName;
        const simIdRight = Array.isArray(simulado.simIdRight) ? simulado.simIdRight : []; // Garante que seja um array

        // Filtra os temas relacionados ao simulado atual
        const themes = this.SimuladosThemes[simName] || []; // Temas do simulado

        // Agrupa os temas e calcula o total de questões e acertos
        const themeData = themes.reduce((acc, item) => {
          const theme = item.theme;
          acc[theme] = acc[theme] || { total: 0, correct: 0 };
          acc[theme].total += 1;
          acc[theme].correct += simIdRight.includes(item.questionId) ? 1 : 0;
          return acc;
        }, {});

        mergedData[simName] = themeData;
      });

      return mergedData;
    },
    themesSummary() {
      const summary = {};

      // Itera sobre cada simulado
      this.simuladosResults.forEach(simulado => {
        const simName = simulado.simName;

        // Garante que simIdRight seja um array de números
        const simIdRight = typeof simulado.simIdRight === 'string' && simulado.simIdRight.trim() !== ''
          ? simulado.simIdRight.split(',').map(Number)
          : Array.isArray(simulado.simIdRight)
          ? simulado.simIdRight.map(Number)
          : [];

        const themes = this.SimuladosThemes[simName] || []; // Temas do simulado

        // Itera sobre os temas do simulado
        themes.forEach(item => {
          const theme = item.theme;

          // Inicializa o tema no resumo, se ainda não existir
          if (!summary[theme]) {
            summary[theme] = { total: 0, correct: 0 };
          }

          // Incrementa o total de questões
          summary[theme].total += 1;

          // Incrementa os acertos se a questão estiver em simIdRight
          if (simIdRight.includes(item.questionId)) {
            summary[theme].correct += 1;
          }
        });
      });

      return summary;
    },
    sortedThemes() {
      // Ordena os temas com base na coluna e direção selecionadas
      return Object.keys(this.themesSummary).sort((a, b) => {
        const themeA = this.themesSummary[a];
        const themeB = this.themesSummary[b];

        let valueA, valueB;

        switch (this.sortColumn) {
          case 'theme':
            valueA = a;
            valueB = b;
            break;
          case 'total':
            valueA = themeA.total;
            valueB = themeB.total;
            break;
          case 'correct':
            valueA = themeA.correct;
            valueB = themeB.correct;
            break;
          case 'accuracy':
            valueA = themeA.correct / themeA.total;
            valueB = themeB.correct / themeB.total;
            break;
        }

        if (this.sortDirection === 'asc') {
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        } else {
          return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
        }
      });
    },
  },
  methods: {
    async loadSimuladosData() {
      const adminValue = this.$store.getters.admin;
      if (typeof adminValue === 'string' && (adminValue.trim() === '' || adminValue.includes(','))) {
        return;
      }

      this.$store.commit('setLoading', true);
      await this.$store.dispatch('loadSimuladosResults', { search: true });
      await this.$store.dispatch('loadSimuladosThemes', { search: true });
      this.$store.commit('setLoading', false);
    },
    // Retorna a classe de cor com base na taxa de acertos e no volume de questões
    getAccuracyColor(percentage, volume) {
      if (volume < 10) {
        return 'custom-text-gray'; // Cinza para volume < 10
      } else if (volume >= 10 && volume < 20) {
        return 'custom-text-yellow'; // Amarelo para 10 ≤ volume < 20
      } else {
        // Aplica a regra atual para volume ≥ 20
        if (percentage < 0.6) {
          return 'custom-text-red'; // Vermelho para < 60%
        } else if (percentage >= 0.6 && percentage <= 0.75) {
          return 'custom-text-yellow'; // Amarelo para 60–75%
        } else {
          return 'custom-text-green'; // Verde para > 75%
        }
      }
    },
    countThemes(themes) {
      return themes.reduce((acc, item) => {
        acc[item.theme] = (acc[item.theme] || 0) + 1;
        return acc;
      }, {});
    },
    sortTable(column) {
      if (this.sortColumn === column) {
        // Inverte a direção se a coluna já estiver selecionada
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Define a nova coluna e reseta a direção para ascendente
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
  },
};
</script>

<style scoped>
.dashboard {
  gap: 16px;
}

.metric-card {
  padding: 12px; /* Reduz o espaçamento interno do card */
  width: 100%;
  max-height: auto; /* Limita a altura do card */
  overflow: hidden; /* Garante que o conteúdo não ultrapasse o card */
}

.v-card-text {
  display: flex;
  flex-direction: column;
}

@media (min-width: 600px) {
  .v-card-text {
    flex-direction: row;
    align-items: center;
  }
}

.ml-4 {
  margin-left: 16px;
}

.text-primary {
  color: #1976d2;
}

@media (max-width: 600px) {
  .metric-card {
    padding: 12px;
  }
}

.chart-container {
  height: 172px; /* Define a altura máxima do gráfico */
  width: 100%; /* Garante que o gráfico ocupe toda a largura disponível */
  position: relative; /* Necessário para o canvas do Chart.js */
}

.taller-chart {
  height: 400px; /* Defina uma altura maior para este gráfico */
  width: 100%; /* Garante que o gráfico ocupe toda a largura disponível */
  position: relative; /* Necessário para o canvas do Chart.js */
}

.simulados-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px; /* Reduz o espaçamento entre as tabelas */
}

.simulados-section {
  flex: 1;
  min-width: 0;
}

.simulados-section h3 {
  text-align: center;
  margin-bottom: 8px; /* Reduz o espaçamento inferior do título */
}

.v-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 0 8px; /* Reduz o espaçamento interno da lista */
}

.simulados-item {
  padding: 4px 0; /* Reduz o espaçamento vertical entre os itens */
}

.sim-item-content {
  display: flex;
  flex-direction: column;
}

.sim-name {
  font-weight: bold;
  white-space: normal; /* Permite quebra de linha */
  overflow: visible; /* Garante que o texto seja exibido completamente */
  word-wrap: break-word; /* Quebra palavras longas, se necessário */
  margin-bottom: 1px; /* Adiciona um pequeno espaçamento abaixo do nome */
}

.sim-percentage {
  margin-top: 1px;
  margin-bottom: 8px; 
  font-size: 0.9rem;
}

.text-red {
  color: #e53935;
  font-weight: bold;
}

.text-yellow {
  color: #0713f3;
  font-weight: bold;
}

.text-green {
  color: #43a047;
  font-weight: bold;
}

.custom-text-red {
  color: #e53935;
  font-weight: bold;
}

.custom-text-yellow {
  color: #ffb300;
  font-weight: bold;
}

.custom-text-green {
  color: #43a047;
  font-weight: bold;
}

.custom-text-gray {
  color: #9e9e9e; /* Cinza */
  font-weight: bold;
}

.theme-name {
  font-weight: bold;
}

.theme-count {
  font-size: 0.9rem;
  color: #757575;
}

.v-simple-table th {
  font-weight: bold;
  background-color: #f5f5f5;
}

.v-simple-table td {
  padding: 8px;
}

.text-center {
  text-align: center;
}

.aesthetic-table {
  border-collapse: collapse;
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.aesthetic-table th {
  background-color: #1976d2;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  padding: 12px;
}

.aesthetic-table td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.aesthetic-table tr:hover {
  background-color: #f1f1f1;
}

.accuracy-percentage {
  font-weight: bold;
}

.accuracy-percentage.custom-text-red {
  color: #e53935;
}

.accuracy-percentage.custom-text-yellow {
  color: #ffb300;
}

.accuracy-percentage.custom-text-green {
  color: #43a047;
}

.table-container {
  max-height: 300px; /* Limita a altura da tabela */
  overflow-x: auto; /* Scroll horizontal */
  overflow-y: auto; /* Scroll vertical */
}

.aesthetic-alert {
  background-color: #f9f9f9;
  border-left: 4px solid #1976d2;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 8px;
}

.aesthetic-alert strong {
  font-size: 1rem;
  color: #1976d2;
}

.aesthetic-alert ul {
  padding-left: 16px;
  margin: 8px 0 0;
}

.aesthetic-alert li {
  margin-bottom: 4px;
  font-size: 0.9rem;
}

.minimal-icon {
  line-height: 1; /* Ajusta o alinhamento vertical do ícone */
  font-size: 1.0rem; /* Aumenta o tamanho do ícone */
}

.help-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 12px; /* Espaçamento entre os itens */
}

.help-item {
  display: flex;
  align-items: center;
  gap: 12px; /* Espaçamento entre o círculo de cor e o texto */
}

.help-color {
  width: 16px;
  height: 16px;
  border-radius: 50%; /* Torna o elemento circular */
  display: inline-block;
}

.help-color.gray {
  background-color: #9e9e9e; /* Cinza */
}

.help-color.red {
  background-color: #e53935; /* Vermelho */
}

.help-color.yellow {
  background-color: #ffb300; /* Amarelo */
}

.help-color.green {
  background-color: #43a047; /* Verde */
}

.v-card-title {

  padding: 16px;
  font-size: 1.25rem;
  font-weight: bold;
}

.v-card-title2 {
  background-color: #1976d2; /* Azul para o título */
  color: white;
  padding: 16px;
  font-size: 1.25rem;
  font-weight: bold;
}
.v-card-actions {
  padding: 16px;
}
.legend-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(25, 118, 210, 0.06); /* leve azul para ficar clean */
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #333;
}

.legend-color {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}

.legend-color.gray { background-color: #9e9e9e; }
.legend-color.red { background-color: #e53935; }
.legend-color.yellow { background-color: #ffb300; }
.legend-color.green { background-color: #43a047; }
</style>
